import dayjs from 'dayjs';
export function isValidYearMonth(yearMonthString) {
    if (!yearMonthString) {
        return false;
    }
    const yearMonthDate = dayjs(yearMonthString, 'YYYY-MM');
    return yearMonthDate.isValid() && yearMonthDate.year() >= 2020 && yearMonthDate.isBefore(dayjs());
}
export function isPreviousYear(currentYearMonth, newYearMonth) {
    const currentDate = dayjs(currentYearMonth, 'YYYY-MM');
    const newDate = dayjs(newYearMonth, 'YYYY-MM');
    if (currentDate.year() - 1 === newDate.year()) {
        return true;
    }
    return false;
}
export function getDiffDaysFromNow(futureTimeUtc, currentTimeUtc) {
    let futureTime = dayjs.utc(futureTimeUtc);
    let nowTime = dayjs.utc(currentTimeUtc || dayjs.utc());
    if (futureTime.isBefore(nowTime)) {
        return -1;
    }
    return futureTime.diff(nowTime, 'days');
}
export function displayTime(timeUtc) {
    return dayjs.utc(timeUtc).tz(dayjs.tz.guess()).format('DD/MM/YYYY hh:mma');
}
export function displayTimeWithTz(timeUtc) {
    return dayjs.utc(timeUtc).tz(dayjs.tz.guess()).format('DD/MM/YYYY hh:mma (Z)');
}
export function displayDate(dateUtc) {
    return dayjs.utc(dateUtc).tz(dayjs.tz.guess()).format('DD/MM/YYYY');
}
export function displayYearMonth(yearMonth) {
    return dayjs(yearMonth, 'YYYY-MM').format('MMMM YYYY');
}
export function isAfterEndOfMonth(yearMonthString, dateUtc) {
    if (dateUtc == null || yearMonthString == null) {
        return false;
    }
    const endOfCurrentMonth = dayjs(yearMonthString, 'YYYY-MM').endOf('month');
    return dayjs(dateUtc).isAfter(endOfCurrentMonth);
}
export function isCurrentMonth(yearMonth) {
    return yearMonth === getCurrentYearMonth();
}
export function getCurrentYearMonth() {
    return dayjs(new Date()).format('YYYY-MM');
}
export function toYearMonth(dayJsDate) {
    return dayJsDate.format('YYYY-MM');
}
